import React, { useMemo, useRef, useState, useCallback } from 'react';
import c from 'classnames';
import { useEnabledFlagList } from '@wix/da-react-context/pkg/flags/hooks/useEnabledFlagList';
import BrandedButton from '@wix/da-ds/pkg/Buttons/BrandedButton';
import AddIcon from '@wix/da-ds/pkg/Icons/24x24/Add';
import { IconSize } from '@wix/da-ds/pkg/Icons/IconWrap';
import { BiData, SubmitMenuOpenBiEvent } from '@wix/da-bi/pkg/events';
import ListMenu, { ListMenuItem } from '../../../_partials/LegacyListMenu';
import { mobileSubmitMenuItems } from '../../../constants';
import SubmitMenuItem from './SubmitMenuItem';
import { useOnOutsideClick } from '@wix/da-hooks/pkg/useOnOutsideClick';

import s from './SubmitDropdown.scss';

interface Props {
  className?: string;
  menuClassName?: string;
}

const SubmitDropdown: React.FC<Props> = ({ className, menuClassName }) => {
  const rootRef = useRef<HTMLDivElement>(null);
  const [isOpen, setOpen] = useState(false);
  const closeMenu = useCallback(() => setOpen(false), []);
  const flags = useEnabledFlagList();

  useOnOutsideClick(rootRef, closeMenu);

  const submitMenuItems = useMemo(() => {
    return mobileSubmitMenuItems
      .filter(item => item && (!item.feature || flags.includes(item.feature)))
      .map(
        ({
          type,
          label,
          target,
          verificationAction = 'submit',
          link,
          modalType,
          modalOptions,
          openInStudio,
        }): ListMenuItem => {
          return {
            key: label,
            renderElement: () => (
              <SubmitMenuItem
                className={s['submit-menu-item']}
                type={type}
                modalType={modalType}
                modalOptions={modalOptions}
                label={label}
                link={link}
                target={target}
                verificationAction={verificationAction}
                openInStudio={openInStudio}
              />
            ),
          };
        }
      );
  }, []);

  return (
    <div className={c(s['root'], className)} ref={rootRef}>
      <BrandedButton
        variant="brand-green"
        size="medium"
        className={s['button']}
        onClick={() => setOpen(open => !open)}
        biData={
          isOpen
            ? undefined
            : BiData<SubmitMenuOpenBiEvent>({
                evid: 703,
                sectionname: 'dropdown',
              })
        }
      >
        <AddIcon
          className={s['icon']}
          size={IconSize.MEDIUM}
          disableDefaultColors
        />
      </BrandedButton>
      {isOpen && (
        <ListMenu
          className={c('ds-surface-tertiary', s['menu'], menuClassName)}
          items={submitMenuItems}
        />
      )}
    </div>
  );
};
SubmitDropdown.displayName = 'SubmitDropdown';

export default SubmitDropdown;
